import { connect, } from 'react-redux';
import { AppState, } from '../../sew-core/types';
import AwardPanel from '../components/AwardPanel';
import { onAwardsInfoClick, } from '../../sew-core/actions';
import { openOverlay } from '../../sew-core/actions';

const mapStateToProps = (state: AppState,) => ({
  vehicleAward: state.vehicleAward,
});

const mapDispatchToProps = (dispatch,) => ({
  onAwardsInfoClick: () => dispatch(onAwardsInfoClick(),),
  openOverlay: (overlayHeader) => dispatch(openOverlay(overlayHeader),)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AwardPanel,);
